export default __webpack_public_path__ + "static/casestudy_5-5c1c9b22f6084d50c6b3db4ff80cdbf4.png";